import { inject, Injectable } from "@angular/core";
import { CerrixDialogComponent } from "./cerrix-dialog.component";
import { TabService } from "@services/tabs/TabService";

@Injectable({
    providedIn: "root",
})
export class CerrixDialogService {
    private tabs = inject(TabService);
    private dialogs: { tabId: string; component: CerrixDialogComponent[] }[] = [];

    addDialog(dialog?: CerrixDialogComponent, tabId?: string) {
        if (dialog && tabId) {
            const existingTab = this.dialogs.find((d) => d.tabId === tabId);
            if (existingTab) {
                existingTab.component.push(dialog);
            } else {
                this.dialogs.push({ tabId, component: [dialog] });
            }
        }
    }

    removeDialog(dialog: CerrixDialogComponent, tabId?: string) {
        const existingTab = this.dialogs.find((d) => d.tabId === tabId);
        if (existingTab) {
            existingTab.component = existingTab.component.filter((d) => d !== dialog);
            if (existingTab.component.length === 0) {
                this.dialogs = this.dialogs.filter((d) => d.tabId !== tabId);
            }
        }
    }

    openDialog(dialogName: string = "") {
        const tabId = this.tabs.activeTab.identifier;
        const existingTab = this.dialogs.find((d) => d.tabId === tabId);
        if (existingTab) {
            let dialogComponent = existingTab.component.find((d) => d.name === dialogName);
            if (!dialogComponent) {
                dialogComponent = existingTab.component[0];
            }
            if (dialogComponent) {
                dialogComponent.openDialog();
            }
        }
    }

    closeDialog(dialogName: string = "") {
        const tabId = this.tabs.activeTab.identifier;
        const existingTab = this.dialogs.find((d) => d.tabId === tabId);
        if (existingTab) {
            let dialogComponent = existingTab.component.find((d) => d.name === dialogName);
            if (!dialogComponent) {
                dialogComponent = existingTab.component[0];
            }
            if (dialogComponent) {
                dialogComponent.closeDialog();
            }
        }
    }
}
